webpackJsonp([241767136424496],{

/***/ 927:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/clients-accor.e44dae1f.png";

/***/ }),

/***/ 928:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/clients-foursisters.bd88c258.png";

/***/ }),

/***/ 929:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/clients-greentree.e7aeb9d4.png";

/***/ }),

/***/ 930:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/clients-ihg.25601434.png";

/***/ }),

/***/ 931:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/clients-kana.133d2a20.png";

/***/ }),

/***/ 932:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/clients-lark.d3358dff.png";

/***/ }),

/***/ 933:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hero.07155499.jpg";

/***/ }),

/***/ 934:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/seo-hero.9ceaa855.png";

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _reactHelmet = __webpack_require__(20);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Section = __webpack_require__(13);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Button = __webpack_require__(12);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SectionTwoCol = __webpack_require__(85);
	
	var _twoCol = __webpack_require__(21);
	
	var _SectionHeader = __webpack_require__(27);
	
	var _SectionHeader2 = _interopRequireDefault(_SectionHeader);
	
	var _SectionPreHeader = __webpack_require__(28);
	
	var _SectionPreHeader2 = _interopRequireDefault(_SectionPreHeader);
	
	var _SubHeader = __webpack_require__(18);
	
	var _SubHeader2 = _interopRequireDefault(_SubHeader);
	
	var _CalloutContainer = __webpack_require__(26);
	
	var _CalloutContainer2 = _interopRequireDefault(_CalloutContainer);
	
	var _HubspotFormSection = __webpack_require__(51);
	
	var _HubspotFormSection2 = _interopRequireDefault(_HubspotFormSection);
	
	var _hero = __webpack_require__(933);
	
	var _hero2 = _interopRequireDefault(_hero);
	
	var _clientsIhg = __webpack_require__(930);
	
	var _clientsIhg2 = _interopRequireDefault(_clientsIhg);
	
	var _clientsLark = __webpack_require__(932);
	
	var _clientsLark2 = _interopRequireDefault(_clientsLark);
	
	var _clientsAccor = __webpack_require__(927);
	
	var _clientsAccor2 = _interopRequireDefault(_clientsAccor);
	
	var _clientsGreentree = __webpack_require__(929);
	
	var _clientsGreentree2 = _interopRequireDefault(_clientsGreentree);
	
	var _clientsKana = __webpack_require__(931);
	
	var _clientsKana2 = _interopRequireDefault(_clientsKana);
	
	var _clientsFoursisters = __webpack_require__(928);
	
	var _clientsFoursisters2 = _interopRequireDefault(_clientsFoursisters);
	
	var _seoHero = __webpack_require__(934);
	
	var _seoHero2 = _interopRequireDefault(_seoHero);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClientsPage = function (_React$Component) {
	  _inherits(ClientsPage, _React$Component);
	
	  function ClientsPage(props) {
	    _classCallCheck(this, ClientsPage);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ClientsPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: 'IHG + Whistle',
	        meta: [{ name: 'og:title', content: 'IHG + Whistle' }, { name: 'description', content: 'Trusted by big brands and independent boutiques.' }, { name: 'og:description', content: 'Trusted by big brands and independent boutiques.' }, { name: 'og:image', content: _seoHero2.default }, { name: 'og:type', content: "website" }, { name: 'og:locale', content: "en_US" }]
	      }),
	      _react2.default.createElement(
	        _twoCol.TwoCol,
	        { bgColor: '#fcc71b' },
	        _react2.default.createElement(
	          _twoCol.LeftCol,
	          { bgColor: '#fcc71b', skew: true, color: '#fff' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Trusted By Brands',
	            _react2.default.createElement('br', null),
	            ' To Independent',
	            _react2.default.createElement('br', null),
	            ' Boutiques'
	          ),
	          _react2.default.createElement(
	            _SubHeader2.default,
	            null,
	            'From large hotel brands to small B&Bs ',
	            _react2.default.createElement('br', null),
	            '\u2014Whistle is the premiere guest ',
	            _react2.default.createElement('br', null),
	            'messaging platform for every',
	            _react2.default.createElement('br', null),
	            ' hospitality company.'
	          ),
	          _react2.default.createElement(
	            _CalloutContainer2.default,
	            { align: 'left' },
	            _react2.default.createElement(
	              _Button2.default,
	              { primary: true, to: '/schedule', icon: true },
	              'Book A Demo'
	            )
	          )
	        ),
	        _react2.default.createElement(_twoCol.RightCol, { image: true, bgImgSrc: _hero2.default })
	      ),
	      _react2.default.createElement(
	        _SectionTwoCol.SectionTwoCol,
	        { light: true },
	        _react2.default.createElement(
	          _SectionTwoCol.SectionColumn,
	          { center: true },
	          _react2.default.createElement('img', { src: _clientsIhg2.default, alt: 'InterContinental Hotels Group Logo' })
	        ),
	        _react2.default.createElement(
	          _SectionTwoCol.SectionColumn,
	          null,
	          _react2.default.createElement(
	            _SectionPreHeader2.default,
	            { align: 'center' },
	            'Hotel Brand'
	          ),
	          _react2.default.createElement(
	            _SectionHeader2.default,
	            { align: 'center', lower: true },
	            'InterContinental Hotels Group'
	          ),
	          _react2.default.createElement(
	            _SubHeader2.default,
	            { align: 'center' },
	            'Whistle is an approved vendor for IHG\'s EMEAA region. From the Holiday Inn brand, to Crowne Plaza and Intercontinental hotels - Whistle provides an unmatched experience for IHG hotels!'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _SectionTwoCol.SectionTwoCol,
	        null,
	        _react2.default.createElement(
	          _SectionTwoCol.SectionColumn,
	          null,
	          _react2.default.createElement(
	            _SectionPreHeader2.default,
	            { align: 'center' },
	            'Botique Hotels'
	          ),
	          _react2.default.createElement(
	            _SectionHeader2.default,
	            { align: 'center', lower: true },
	            'Lark Hotels'
	          ),
	          _react2.default.createElement(
	            _SubHeader2.default,
	            { align: 'center' },
	            'A boutique collection in New England and beyond, with iconic destinations such as Nantucket, Portland Maine, Stowe, Napa, Mendocino and much more! Lark hotels utilize Whistle across all 28 hotels.'
	          )
	        ),
	        _react2.default.createElement(
	          _SectionTwoCol.SectionColumn,
	          null,
	          _react2.default.createElement('img', { src: _clientsLark2.default, alt: 'Lark Hotels Logo' })
	        )
	      ),
	      _react2.default.createElement(
	        _SectionTwoCol.SectionTwoCol,
	        { light: true },
	        _react2.default.createElement(
	          _SectionTwoCol.SectionColumn,
	          { center: true },
	          _react2.default.createElement('img', { src: _clientsAccor2.default, alt: 'Accor Logo' })
	        ),
	        _react2.default.createElement(
	          _SectionTwoCol.SectionColumn,
	          null,
	          _react2.default.createElement(
	            _SectionPreHeader2.default,
	            { align: 'center' },
	            'Franchise Hotelier'
	          ),
	          _react2.default.createElement(
	            _SectionHeader2.default,
	            { align: 'center', lower: true },
	            'Accor'
	          ),
	          _react2.default.createElement(
	            _SubHeader2.default,
	            { align: 'center' },
	            'Accor is the single largest hospitality company in Europe, and the sixth largest worldwide. Find out how major Accor brands across the world are using Whistle to elevate their guest experience!'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _SectionTwoCol.SectionTwoCol,
	        null,
	        _react2.default.createElement(
	          _SectionTwoCol.SectionColumn,
	          null,
	          _react2.default.createElement(
	            _SectionPreHeader2.default,
	            { align: 'center' },
	            'Independent Boutiques'
	          ),
	          _react2.default.createElement(
	            _SectionHeader2.default,
	            { align: 'center', lower: true },
	            'Four Sisters Inns'
	          ),
	          _react2.default.createElement(
	            _SubHeader2.default,
	            { align: 'center' },
	            'Four Sisters Inns is a collection of 18 extraordinary boutique inns and hotels, located in California\'s most spectacular destinations. By fully integrating with their PMS and contactless check-in tools, Whistle has been key for Four Sisters Inns\' operations.'
	          )
	        ),
	        _react2.default.createElement(
	          _SectionTwoCol.SectionColumn,
	          null,
	          _react2.default.createElement('img', { src: _clientsFoursisters2.default, alt: 'Four Sisters InnsLogo' })
	        )
	      ),
	      _react2.default.createElement(
	        _SectionTwoCol.SectionTwoCol,
	        { light: true },
	        _react2.default.createElement(
	          _SectionTwoCol.SectionColumn,
	          { center: true },
	          _react2.default.createElement('img', { src: _clientsKana2.default, alt: 'Kana Hotel Group Logo' })
	        ),
	        _react2.default.createElement(
	          _SectionTwoCol.SectionColumn,
	          null,
	          _react2.default.createElement(
	            _SectionPreHeader2.default,
	            { align: 'center' },
	            'Management Group'
	          ),
	          _react2.default.createElement(
	            _SectionHeader2.default,
	            { align: 'center' },
	            'Kana Hotel Group'
	          ),
	          _react2.default.createElement(
	            _SubHeader2.default,
	            { align: 'center' },
	            'With over 60 branded hotels under their management, Kana Hotel Group relies on Whistle to provide seamless messaging across their portfolio of branded hotels.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _SectionTwoCol.SectionTwoCol,
	        null,
	        _react2.default.createElement(
	          _SectionTwoCol.SectionColumn,
	          null,
	          _react2.default.createElement(
	            _SectionPreHeader2.default,
	            { align: 'center' },
	            'MID-SCALE HOTELS'
	          ),
	          _react2.default.createElement(
	            _SectionHeader2.default,
	            { align: 'center', lower: true },
	            'GreenTree Inn'
	          ),
	          _react2.default.createElement(
	            _SubHeader2.default,
	            { align: 'center' },
	            'GreenTree Inn is successful brand in Asia with over 2,500 hotels worldwide. What started as one hotel in Phoenix, has now quickly grown throughout the Southwest through corporate acquisition and franchise development.'
	          )
	        ),
	        _react2.default.createElement(
	          _SectionTwoCol.SectionColumn,
	          null,
	          _react2.default.createElement('img', { src: _clientsGreentree2.default, alt: 'GreenTree Inn Logo' })
	        )
	      ),
	      _react2.default.createElement(_HubspotFormSection2.default, {
	        primary: true,
	        id: 'book-demo',
	        formId: '7d86c04f-e98e-42eb-ae79-ff2b14c7605a',
	        trackingId: ("AW-844932343/Jf_qCLeXzeYBEPfJ8pID")
	      })
	    );
	  };
	
	  return ClientsPage;
	}(_react2.default.Component);
	
	exports.default = ClientsPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-clients-js-f426aef527cbfef2131b.js